import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import moment, { min } from "moment";
import { estructura_producto, estructuraLogsFServ } from "../../utils/estructuras";

import './ModalFormComprobaciones.css';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleXmark,faFloppyDisk,faSearch, faThumbsDown, faThumbsUp, faCaretDown, faCaretUp, faSave } from "@fortawesome/free-solid-svg-icons";

// Alertas
import Swal from 'sweetalert2'
import SelectControl from "../SelecControl/SelectControl";

import {addToDate, getDifferenceInDays, getNewFormattedDate} from '../../utils/funciones'
import activoTypeContext from "../../context/activoTypeContex/activoTypeContex";
import ModalFormLectura from "./ModalFormLectura";
import Stopwatch from "../stopwatch/Stopwatch";
import { ModalFormCombustible } from "./ModalFormCombustible";
import ModalAssociateCKtoTDoc from "./ModalAssociateCKtoTDoc";

const ModalFormComprobaciones = ({activo,checklistsFiltradas,usuario,index,minimizar,agregarChecklistReg,getLastLecturaByUnidadAndActivo,addLectura,getLectsByActivoId, calcularMantenimientoByActivo, addProcedimientoProgramado, procedimientoCtrlFallidos, setChecklistSaved, componentePadre, updateUserWorking, getTDocsWithCKAssociated, associateNroCKtoODT}) => {

    const [checkSelected,setCheckSelected] = useState({});
    const [checks,setChecks] = useState([]);
    const checksChecked = checks.filter(c => c.checked != undefined && (c.checked == "positive" || (c.checked == 'negative' && c.textAdic != ''))).length;
    const [showChecked,setShowChecked] = useState(false);
    const [showModalCombustible, setShowModalCombustible] = useState(false);
    const [showModalLectura,setShowModalLectura] = useState(false);
    const [showStopwatch, setShowStopwatch] = useState(false);
    const [firstLectura,setFirstLectura] = useState(true);
    const [disabledBtn,setDisabledBtn] = useState(true);
    const [startDate,setStartDate] = useState(null);
    const [timer,setTimer] = useState(0);
    const navigate = useNavigate();
    
    const inputsRef = useRef([]);
    const singleRef = useRef(null);

    const savingDirectly = useRef(false);
    const [tDocsToAssociate,setTDocsToAssociate] = useState([]);
    const [modalToShow, setModalToShow] = useState('');
    const [ctrlClicked, setCtrlClicked] = useState(null);

    const handleChange = (e,prop) =>{
        let controles = e.controles.map(c => ({...c})); //Para no setear checks por referencia, evitando asi modificar el arreglo original.
        setCheckSelected({...e});
        setChecks(controles);
        setShowModalLectura(true);
    } 

    //Crear Procedimiento Programado y redigirir a addReq generando una OT sobre este procedimiento.
    const handleSaveComprobaciones = async(directo = false) =>{
        savingDirectly.current = directo;
        if(checkSelected.solicitaCantCombustible) setShowModalCombustible(true);
        else{
            saveComprobaciones();            
        }
    }

    const saveProcProgramado = async(checklistReg) =>{
        let newFec = new Date();
        try {
            let procModelado = {
                codActivo: activo.codActivo,
                codProc: 'CTRLFALLIDOS',
                codChecklistReg: checklistReg.codigo,
                nroChecklistReg: checklistReg.checkNro,
                uniMed: 'DAYS',
                valorLecturaUltima: getNewFormattedDate(),
                valorLecturaVencimiento: getNewFormattedDate(addToDate(new Date(),31,'day','add')),
                valorLecturaAlerta: getNewFormattedDate(addToDate(new Date(),28,'day','add')),
                valorLecturaCompletado: "",
                fechaVencimiento: getNewFormattedDate(addToDate(new Date(),31,'day','add')),
                fechaCompletado: '',
                CodForOT:'',
                NroForOT:'0',
                tipoAlerta:'PorVENC',
                state:'PEND',
                originado: "CHECKLIST",
                fecMod: newFec,
                fecAlt: newFec,
                activoID: activo._id,
                procedimientoID: procedimientoCtrlFallidos._id,
                checklistRegID: checklistReg._id
            }
            let res = await addProcedimientoProgramado(procModelado);
        }catch(error){
            console.log(error);
        }
    }

    const saveComprobaciones = async(combustibleSelected = null) =>{
        const newDate = moment();

        let checkModelado = {codigo:checkSelected.value, codActivo: activo.codActivo, activoID: activo._id, checklistID:checkSelected.id, name:checkSelected.label,  tipAct:checkSelected.tipAct, controles:checks.map(c => ({...c})), fecInicio: newDate.format('YYYY-MM-DD HH:mm:ss'), userName: usuario.userName, comUserID:usuario._id};
        
        if(combustibleSelected) checkModelado.cantidadCombustible = combustibleSelected;
        if(savingDirectly.current){
            checkModelado.state = 'FINALIZADO';
            checkModelado.fecFin = newDate.format('YYYY-MM-DD HH:mm:ss');
            checkModelado.endedDirectly = true;
        }

        let checksFallidos = checks.filter(c => c.checked == 'negative');

        let res = await agregarChecklistReg(checkModelado);
        if(res.checkNro){
            Swal.fire({
                title: "Se guardo un nuevo registro de checklist!",
                text: `El registro generado es : ${res.codigo} - ${res.checkNro}`,
                icon:'success',
                allowEnterKey:true,
                showConfirmButton:true
            });
            if(checksFallidos.length > 0){
                saveProcProgramado(res);
            }
            (componentePadre == "SelectActivo") && setChecklistSaved({...res, visualizarCrono: (checkSelected.visualizarCrono && checkSelected.visualizarCrono == true) ? true : false});
            console.log("!savingDirectly.current");
            console.log(!savingDirectly.current);
            
            if(!savingDirectly.current) await updateUserWorking(activo._id, usuario.userName);
            else{
                let tDocs = await getTDocsWithCKAssociated(checkSelected._id, activo._id);
                console.log("tDocs");
                console.log(tDocs);
                
                if(Array.isArray(tDocs) && tDocs.length > 0){
                    setTDocsToAssociate(tDocs);
                    setModalToShow('associateCkToTDoc');
                    setCheckSelected(res)
                    savingDirectly.current = false;
                    return;
                }
                savingDirectly.current = false;
            } 
            minimizar(true);
        }else Swal.fire({
            title: `Algo no funciono segun lo esperado!`,
            icon: 'error',
            text: `Hubo un inconveniente desconocido, reporteselo a consultoria!`,
            showConfirmButton: true,
            allowEnterKey: true
        });
    }

    const handleCheckPoint = (e,i,property='',value='', source = 'undirect') =>{
        setChecks(prevChecks => {
            let newChecks = prevChecks.slice();
            if(property != ''){
                newChecks[i][property] = value;
                if(['positive','negative',''].includes(value)) newChecks[i]['textAdic'] = ''
            }else{
                newChecks[i][e.target.name] = e.target.value;
            }
            
            (!newChecks.some(c => c.checked == "negative" && c.textAdic == "")) ? setDisabledBtn(false) : setDisabledBtn(true);
            return newChecks;
        })
        if(source == 'direct'){
            setCtrlClicked(null);
        }
    }

    const handleMinimizarModalLectura = async(flag, accion) =>{
        if(firstLectura && accion == 'close'){
            minimizar();
        }else if(firstLectura){
            setFirstLectura(false);
        }
        setShowModalLectura(false);
        if(flag && !firstLectura){
            await saveComprobaciones();
        }
    }
    
    const handleMinimizarModalCombustible = async(cantidadCombustible) =>{
        setShowModalCombustible(false);
        await saveComprobaciones(cantidadCombustible);
    }

    const saveTextAdic = (i, source='undirect') =>{
        let value;
        if(source == 'direct'){
            value = singleRef.current.value;
            setChecks(prevChecks => {
                let newChecks = prevChecks.slice();
                newChecks[i].checked = 'negative';
                newChecks[i].textAdic = value;
                return newChecks;
            })
            setCtrlClicked(null);
        }else{
            value = inputsRef.current[i].value;
            handleCheckPoint({},i,'textAdic',value);
        }
    }

    const handleClickClicked = (e, c) => {
        e.preventDefault();
        e.stopPropagation();
        if(!c.checked) setCtrlClicked({...c, ctrlsIndex: checks.findIndex(check => check.x == c.x)});
    }

    const handleCloseCtrlClicked = e => {
        e.preventDefault();
        setCtrlClicked(null);
    }

    useEffect(()=>{
        console.log("Timer pausado, resultado de tiempo inicial + timer:");
        console.log(moment(startDate).format('YYYY-MM-DD HH:mm:ss'));
        console.log(moment(startDate).add(timer,'seconds').format('YYYY-MM-DD HH:mm:ss'));
    },[timer])

    useEffect(()=>{
        if(checksChecked == 0) setShowChecked(false);
    },[checksChecked])

    return <div className={`${Object.keys(checkSelected).length == 0 ? 'checkNotSelectedYet' : ''} modalFormDiv modalFormComprobacionesDiv`}>
        <button className="minimizarBtn" onClick={()=>minimizar(false)}>X</button>
        {
            Object.keys(checkSelected).length == 0 && <h6 style={{textAlign:'center', marginTop:'0.25rem'}}>Seleccione un Checklist para {activo.codActivo} - {activo.name}</h6>
        }
        {
            Object.keys(checkSelected).length == 0 ? <SelectControl style={{alignSelf:'center'}} placeholder={"Seleccione un checklist..."} disabled={Object.keys(checkSelected).length > 0} modo='Nuevo' idSelect={"procedimientoXactivo"} handleChengeSelect={handleChange} optionsSelect={checklistsFiltradas.map(check => {return {...check, label:check.name, value:check.codigo, tipAct:check.tipAct, id:check._id, visualizarCrono: (check.visualizarCrono && check.visualizarCrono == true) ? true : false, controles:check.controles}})} valueSeleccionada={checkSelected} tipo={'modalProcedimientoXActivo'} selectSelect={handleChange} index={index} setNuevoEditado={'Ninguno'} propToChange="procedimiento"/> : <label style={{fontWeight:600, fontSize:24, flex: 0.25, textAlign:'center', marginTop:'0.25rem'}}>{checkSelected.name} - {activo.name}</label>
        }
        <div className="bodyModalForm comprobacionesCtrls" >
            {
                (checkSelected?.imgUrl || checkSelected?.imgUrl2) && <div style={{display: 'flex', flexDirection:'column', height:'100%', overflowY:'auto', justifyContent:'center'}}>
                    {
                        //Renderizado de imagen y sus controles si es que el Checklist posee una.
                        checkSelected?.imgUrl && <div className="imgCtrlsContainer" style={{position:'relative', display:'inline-block', marginBottom:20}}>
                            <img src={checkSelected.imgUrl} style={{ maxWidth: '650px', maxHeight: '450px'}}/>
                            {   
                                checks.filter(c => c.x && c.y && c.imgNro == 1).map((c, i) => <div key={i} className="clickOnImageDiv" 
                                    style={{ 
                                        position:'absolute', 
                                        zIndex:999,
                                        padding: 10,
                                        top: `${c.y}%`, left: `${c.x}%`,
                                        transform: 'translate(-50%, -50%)',
                                        display: 'flex',
                                        gap: 4,
                                        cursor: c.checked ? 'default' : 'pointer'
                                    }}
                                    title={c.checked ? '' : c.name}
                                    onClick={(e) => handleClickClicked(e, c)}
                                    onContextMenu={e => e.preventDefault()}
                                    >
                                        {(!c.checked || c.checked == 'negative') && <FontAwesomeIcon className="thumbImgCtrls" style={{color: c.checked ? 'gray' : 'red'}} icon={faThumbsDown}/>}
                                        {(!c.checked || c.checked == 'positive') && <FontAwesomeIcon className="thumbImgCtrls" style={{color: c.checked ? 'gray' : 'green'}} icon={faThumbsUp}/>}
                                </div>)
                            }
                        </div>
                    }
                    
                    {
                        //Renderizado de imagen y sus controles si es que el Checklist posee una.
                        checkSelected?.imgUrl2 && <div className="imgCtrlsContainer" style={{position:'relative', display:'inline-block', marginBottom:20}}>
                            <img src={checkSelected.imgUrl2} style={{ maxWidth: '650px', maxHeight: '450px'}}/>
                            {   
                                checks.filter(c => c.x && c.y && c.imgNro == 2).map((c, i) => <div key={i} className="clickOnImageDiv" 
                                    style={{ 
                                        position:'absolute', 
                                        zIndex:999,
                                        padding: 10,
                                        top: `${c.y}%`, left: `${c.x}%`,
                                        transform: 'translate(-50%, -50%)',
                                        display: 'flex',
                                        gap: 4,
                                        cursor: c.checked ? 'default' : 'pointer'
                                    }}
                                    title={c.checked ? '' : c.name}
                                    onClick={(e) => handleClickClicked(e, c)}
                                    onContextMenu={e => e.preventDefault()}
                                    >
                                        {(!c.checked || c.checked == 'negative') && <FontAwesomeIcon className="thumbImgCtrls" style={{color: c.checked ? 'gray' : 'red'}} icon={faThumbsDown}/>}
                                        {(!c.checked || c.checked == 'positive') && <FontAwesomeIcon className="thumbImgCtrls" style={{color: c.checked ? 'gray' : 'green'}} icon={faThumbsUp}/>}
                                </div>)
                            }
                        </div>
                    }
                </div>
            }


            <div className="checksContainers">
                {
                    Object.keys(checkSelected).length > 0 && <div className="checksDiv completed">
                        <label onClick={()=>checksChecked > 0 && setShowChecked(!showChecked)}>
                            <FontAwesomeIcon className="iconCheckRow" icon={(showChecked) ? faCaretUp : faCaretDown} />
                            <h6>Controles Revisados {checksChecked} / {checks.length}</h6>
                            <FontAwesomeIcon className="iconCheckRow" icon={(showChecked) ? faCaretUp : faCaretDown} />
                        </label>
                        <div className="checkedDiv" style={{display:(checksChecked > 0 && showChecked) ? 'flex' : 'none' }}>
                            {checks.map((c,i)=> (c.checked != undefined && (c.checked == "positive" || (c.checked == 'negative' && c.textAdic != ""))) && <div className="alreadyCheckRow">
                                <div className="alreadyCheckHeaderDiv">
                                    <h5>{c.descrp}</h5>
                                    <button onClick={()=>handleCheckPoint({},i,'checked','')}><FontAwesomeIcon className="iconCheckRow" icon={faRectangleXmark} /></button>
                                </div>
                                {(c.checked == 'negative') &&  <input name="textAdic" value={(c.textAdic != undefined) ? c.textAdic : ''} disabled onChange={(e)=>handleCheckPoint(e,i)}/>}
                            </div>)}
                        </div>
                    </div>
                }
                {
                    Object.keys(checkSelected).length > 0 && <div className="checksDiv">
                        {checks.map((c,i) => ((c.checked == 'negative' && c.textAdic == '')  || c.checked == '' || c.checked == undefined) && <div className="checkDiv" key={`${c.codigo}-${i}`}>
                            <div className="checkRow">
                                <FontAwesomeIcon style={{color:'red'}} icon={faThumbsDown} id="negativeThumb" name="negative" onClick={(e) => handleCheckPoint({},i,'checked',"negative")}/>
                                <div className="headerCheckRow" id="rowCheckRow">
                                    {c.codigo} - {c.name} {c.showDescrp ? <label style={{fontWeight:500, userSelect:'none', color:'blue', fontSize:36, marginLeft:"8", paddingRight:4, paddingLeft:4}} title={c.descrp}>!!</label> : ''}
                                </div>
                                <FontAwesomeIcon style={{color:'green'}} icon={faThumbsUp} id="positiveThumb" name="positive" onClick={(e) => handleCheckPoint({},i,'checked','positive')}/>
                            </div>
                            {(c.checked == 'negative') && <div className="textAdicCheckDiv">
                                <FontAwesomeIcon className="iconCheckRow" icon={faSave} onClick={()=>saveTextAdic(i)}/>
                                <input ref={(el) => inputsRef.current[i] = el}/>
                            </div>}
                        </div>)}
                    </div>
                }
            </div>
        </div>
        <div className="buttonsModalDiv">
            <button className={`modalFormBtn ${(checksChecked < checks.length || disabledBtn) ? 'disabled' : ''} `} id="saveModalBtn" disabled={(checksChecked < checks.length || disabledBtn)} onClick={()=>handleSaveComprobaciones(true)}>Guardar y Finalizar</button>    
            
            {/* <button className={`modalFormBtn ${(checksChecked < checks.length || disabledBtn) ? 'disabled' : ''} `} id="saveModalBtn" disabled={(checksChecked < checks.length || disabledBtn)} onClick={()=>saveComprobaciones()}>Guardar</button>     */}
            <button className={`modalFormBtn ${(checksChecked < checks.length || disabledBtn) ? 'disabled' : ''} `} id="saveModalBtn" disabled={(checksChecked < checks.length || disabledBtn)} onClick={()=>handleSaveComprobaciones()}>Guardar</button>    
            
            <button className="modalFormBtn" id="cancelBtn" onClick={()=>minimizar(false)}>Cancelar</button>    
        </div>
        {
            ctrlClicked && <div className="detailingCtrlContainerModal">
                <div className="detailingCtrlContainer">
                    <button className="minimizarBtn" onClick={handleCloseCtrlClicked}>X</button>
                    <div className="checkRow">
                        <FontAwesomeIcon style={{color:'red'}} icon={faThumbsDown} id="negativeThumb" name="negative" onClick={(e) => setCtrlClicked({...ctrlClicked, checked: 'negative'})}/>
                        <div className="headerCheckRow" id="rowCheckRow">
                            {ctrlClicked.codigo} - {ctrlClicked.name} {ctrlClicked.showDescrp ? <label style={{fontWeight:500, userSelect:'none', color:'blue', fontSize:36, marginLeft:"8", paddingRight:4, paddingLeft:4}} title={ctrlClicked.descrp}>!!</label> : ''}
                        </div>
                        <FontAwesomeIcon style={{color:'green'}} icon={faThumbsUp} id="positiveThumb" name="positive" onClick={(e) => handleCheckPoint({}, ctrlClicked.ctrlsIndex,'checked','positive', 'direct')}/>
                    </div>
                    {
                        (ctrlClicked.checked == 'negative') && <div className="textAdicCheckDiv">
                            <FontAwesomeIcon className="iconCheckRow" icon={faSave} onClick={()=>saveTextAdic(ctrlClicked.ctrlsIndex, 'direct')}/>
                            <input ref={singleRef}/>
                        </div>
                    }
                </div>
            </div>
        }
        {
            showModalLectura && <div className="modalFormContainer">
                <ModalFormLectura activo={activo} usuario={usuario} index={index} minimizar={handleMinimizarModalLectura} getLastLecturaByUnidadAndActivo={getLastLecturaByUnidadAndActivo} addLectura={addLectura} getLectsByActivoId={getLectsByActivoId} calcularMantenimientoByActivo={calcularMantenimientoByActivo} componentePadre="ModalComprobaciones" firstRender={firstLectura}/>
            </div>
        }
        {
            showStopwatch && <div className="modalFormContainer">
                <Stopwatch setShowStopwatch={setShowStopwatch} setTimer={setTimer}/>
            </div>
        }
        {
            showModalCombustible && <div className="modalFormContainer">
                <ModalFormCombustible activoName={activo.name} setShowModalCombustible={setShowModalCombustible} handleMinimizarModalCombustible={handleMinimizarModalCombustible} minimizar={minimizar}/>
            </div> 
        }
        {
            modalToShow == 'associateCkToTDoc' && <ModalAssociateCKtoTDoc activo={activo} usuario={usuario} index={index} minimizar={minimizar} associateNroCKtoODT={associateNroCKtoODT} tDocsToAssociate={tDocsToAssociate} componentePadre={componentePadre} checklistSaved={checkSelected}/>
        }        
    </div>
}

export default ModalFormComprobaciones;